module.exports = __webpack_public_path__ + "img/21.97e1edea.jpg";